import React from 'react';
import { Input, InputGroup } from 'reactstrap';
import { IndicatorStateOptions } from '../../Indicator';

export type TextInputRenderProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  indicatorState?: IndicatorStateOptions;
  text?: string;
  enabled?: boolean;
  error?: string;
  disabled?: boolean;
  name: string;
  check?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: any;
};

const TextInput = (props: TextInputRenderProps) => {
  const { text, enabled } = props;
  return enabled === undefined || enabled ? (
    <InputGroup>
      <Input
        placeholder={text}
        type="textarea"
        name={props.name}
        checked={props.check}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        onChange={props.onChange}
        value={props.value}
        disabled={props.disabled}
      />
    </InputGroup>
  ) : null;
};
export default TextInput;
